import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RolesType } from 'src/app/enums/RolesType.enum';
import { DetallesEmpresa, VacantesCategorias, VacantesEstados, VacantesPublicadas } from 'src/app/interfaces/empresas';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { EmpresaService } from 'src/app/services/empresa/empresa.service';
import { environment } from 'src/environments/environment';
import { ModalMessageComponent } from '../../common/modalmessage/modalmessage.component';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss']
})
export class CompanyDetailsComponent implements OnInit {

    detallesempresa: DetallesEmpresa;
    vacantescategorias: VacantesCategorias[];
    vacantesestado: VacantesEstados[];
    vacantespublicadas: VacantesPublicadas;
    vacantescategoriasize: number;
    vacantespublicadasExito: boolean;
    usuario: JwtResponse;
    idEmpresaTemp: number;
    verArchivos: String;

  constructor(private empresaService: EmpresaService, private activatedRoute: ActivatedRoute, private title: Title, private meta: Meta,
    private modalService: NgbModal, private router: Router) {
      this.detallesempresa = {} as DetallesEmpresa;
      this.vacantespublicadas = {} as VacantesPublicadas;
      this.vacantescategoriasize = 0;
      this.usuario = JSON.parse(localStorage.getItem('currentUser'));
      this.verArchivos = environment.baseArchivos;
  }

  ngOnInit(): void {
   if(this.usuario && this.usuario.role == RolesType.CANDIDATOS){
    this.idEmpresaTemp = this.activatedRoute.snapshot.params.idEmpresa;
    this.obtenerDetallesEmpresa(this.idEmpresaTemp);
    this.obtenerCategoriasVacantes(this.idEmpresaTemp);
    this.obtenesEstadosVacantes();
    this.obtenerVacantesPublicadas(this.idEmpresaTemp);
    this.getIdEmpresa(this.idEmpresaTemp);
   }else{
    this.abrirModalMessage("Alerta", "Usted no tiene permitido acceder a esta página");
    if(this.usuario && this.usuario.role == RolesType.EMPRESAS){
        this.router.navigate(['/empresa']);
    }else{
        this.router.navigate(['/']);
    }
   }
  }

  private agregarMetaData(): void {
    this.title.setTitle('Detalles de Empresa');
    this.meta.updateTag({name: "description", content: this.cortarTextoDescripcion()});//falta descripcion e imagen para mostrar en open graph
    this.meta.updateTag({name: "keywords", content: "registro, empresas, postulaciones, cuenta, vacantes"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Detalles de Empresa"});
    this.meta.updateTag({property: "og:description", content: this.cortarTextoDescripcion()});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Detalles de Empresa"});
    this.meta.updateTag({name: "twitter:description", content:this.cortarTextoDescripcion()});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  async obtenerDetallesEmpresa(idEmpresa: number){
    try {
        const response = await this.empresaService.obtenerDetallesEmpresa(idEmpresa);
        this.detallesempresa = response.data;
        this.detallesempresa.logo = (this.detallesempresa.logo != environment.empresaDefault ? this.verArchivos + this.detallesempresa.logo : this.detallesempresa.logo);
        this.agregarMetaData();
    } catch (error) {
        console.error("Error al traer detalles de empresa", error);
    }
  }

  private cortarTextoDescripcion () : string {
    let nuevaDescripcion: string;

    if(this.detallesempresa.descripcion.length > 90){
      nuevaDescripcion = this.detallesempresa.descripcion.substring(0,90);
      nuevaDescripcion += "..."
    }else {
      nuevaDescripcion = this.detallesempresa.descripcion;
    }

    return nuevaDescripcion;
}

  async obtenerCategoriasVacantes(idEmpresa: number){
    try {
        const response = await this.empresaService.obtenerVacantesCategorias(idEmpresa);
        this.vacantescategorias = response.data
        this.vacantescategoriasize = this.vacantescategorias.length;
    } catch (error) {
        console.error("Error al traer vacantes por categoria", error);
    }
  }

  async obtenesEstadosVacantes(){
    try {
        const response = await this.empresaService.obtenerVacantesEstados();
        this.vacantesestado = response.data;
    } catch (error) {
        console.error("Error al traer vacantes por estado", error);
    }
  }

  async obtenerVacantesPublicadas(idEmpresa: number){
    try {
        const response = await this.empresaService.obtenerVacantesPublicadas(idEmpresa);
        this.vacantespublicadas = response.data;
        if(this.vacantespublicadas.numeroVacantes == 0){
            this.vacantespublicadasExito = false;
        }
    } catch (error) {
        console.error("Error al traer vacantes Publicadas", error);
    }
  }

  routerLinkVacantesEmpresa(idEmpresa: number){
    if(idEmpresa){
      this.router.navigate(['/vacantes'], { queryParams: { empresa: idEmpresa } });
    }
  }

  getIdEmpresa(idEmpresa: number): void{
    const idEmpresaTemporal:any = localStorage.getItem('idEmpresa')
    if(idEmpresaTemporal){
      localStorage.removeItem('idEmpresa');
    }
    localStorage.setItem('idEmpresa', idEmpresa.toString());
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }
}
